import { TableColumnPlusBeforeIcon } from './TableColumnPlusBeforeIcon';

/**
 * author: Austin Andrews
 * id 67B4875F-B08F-4006-AFE1-9C243F8B873A
 * name table-column-plus-before
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-column-plus-before.svg
 * tags
 * - Text / Content / Format 
 */
export const TableColumnAddBeforeIcon = TableColumnPlusBeforeIcon;
export default TableColumnAddBeforeIcon